// src/config/statusExplanations.js

export const statusExplanations = {
  'Complete': 'Fully closed – all deliverables, approvals, documentation, and billing finished',
  'Accounting Hold - Past Due Unpaid Invoices': 'Past due invoice balances – further work on project on hold until resolved',
  'Project Hold': 'Project placed on hold by client',
  'Cancelled': 'Project cancelled by client',
  'On Track': 'No status flags applied',
  'In Progress': 'No status flags applied',
};
